import React from 'react'
import { Translations } from '../../../shared/i18n/Translations'
import { Lozenge } from '../../../shared/webcomponents/react-wrappers/Lozenge'

/** A lozenge that indicates a task/action has training recommendations which the user has not yet completed */
export function MissingTrainingLozenge() {
    return <Lozenge color="orange" icon="warning-triangle" label={Translations.t('appcore:Training.missingTraining')} />
}
